var agp = agp || {};

agp.track = (function () {
    // Track

    this.dataLayerPush = function (params) {
        var _dataLayer = window.dataLayer || [];
        window.dataLayer = _dataLayer;

        _dataLayer.push(params);

        agp.Debug.log('Track.dataLayerPush() - ', params, _dataLayer);

        return _dataLayer;
    }

    this.hasGTM = function () {
        return !!window.google_tag_manager; // Apparently this is the best way to check if GTM is loaded. The var comes with the GTM snippet, so shouldn't be there if it hasn't loaded. And the GTM API documentation mentions no way to check for load. We need to check for load, because links will fail if we dont becasue of the way we use eventCallback. 
    }

    this.trackevent = function (data, eventCallback) {
        var def = {
                'event': 'event'
            },
            obj;

        if (typeof data === 'string') {
            data = $.parseJSON(data);
        }
        obj = $.extend({}, def, data);

        if (typeof eventCallback === 'function') {
            obj.eventCallback = eventCallback;
        }

        if (typeof obj.eventCallback === 'function' && !this.hasGTM()) { // If we have a callback and GTM is not available, push the data object without the callback in high hopes of GTM to catch it later, then immediately execute the callback to avoid UI sluggishness.
            delete obj.eventCallback;
            this.dataLayerPush(obj);

            eventCallback();
        } else {
            this.dataLayerPush(obj);
        }
    }

    // Udskriv indberetninger
    this.udskrivIndberetninger = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Klik på udskriv indberetninger',
                'label': 'Indberetninger'

            }
        });
    }

    // Gem og udskriv indberetninger
    this.gemOgUdskrivIndberetninger = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Klik på gem og udskriv indberetninger',
                'label': 'Indberetninger'

            }
        });
    }

    // Gem indberetninger
    this.gemIndberetninger = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Klik på gem indberetninger',
                'label': 'Indberetninger'
            }
        });
    }

    // Opret ny medarbejder
    this.opretNyMedarbejder = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Klik på Opret Ny Medarbejder',
                'label': 'Indberetninger'
            }
        });
    }

    // Importer fil knap
    this.importerFraFil = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Klik på Importer fra fil knap',
                'label': 'Indberetninger fra fil'
            }
        });
    }

    // Gem arbejdsgiveroplysninger
    this.gemArbejdsgiverOplysninger = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Klik på Gem arbejdsgiver oplysninger',
                'label': 'Arbejdsgiverdata'
            }
        });
    }

    // Login via Nøglefil
    this.loginMedNogleFil = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Logget ind med nøglefil',
                'label': 'Login'
            }
        });
    }

    // Login via Nøglekort
    this.loginMedNogleKort = function () {
        agp.track.trackevent({
            'event data': {
                'category': 'Support',
                'action': 'Logget ind med nøglekort',
                'label': 'Login'
            }
        });
    }

    this.bind = function () {
        $(document.body)
            // Generic bind on data attributes
            .on('click', '[data-layer-event]', function () {
                agp.track.trackevent($(this).data('layer-event'));
            })
            //.on('click', '.focus-box--info-id-1', function () {
            //    agp.track.trackevent(
            //            {
            //                'event data': {
            //                    'category': 'Login',
            //                    'action': 'Klik på Nøglefil tab',
            //                    "label": "Loginmenu"
            //                }
            //            }
            //    );

            //})
            .on('click', '.header-nav__link', function () {
                agp.track.trackevent({
                    'event data': {
                        'category': 'Topmenuen',
                        'action': 'Tidligere indberetninger',
                        "label": "Topmenu"
                    }
                });

            })

            // Support tel
            .on('click', '.site-footer-icon__phone', function () {
                agp.track.trackevent({
                    'event data': {
                        category: 'Support',
                        action: 'Klik på telefonnummer',
                        'label': 'Kontakt'
                    }
                });
            })

            // Nøglekort submit click
            .on('click', '.Box-Button-Submit', function () {
                agp.track.trackevent({
                    'event data': {
                        'category': 'Support',
                        'action': 'Klik på nøglekort login',
                        'label': 'Kontakt'
                    }
                });
            })


            // Importer fra fil download skabelon
            .on('click', '.download-template a', function () {
                agp.track.trackevent({
                    'event data': {
                        'category': 'Support',
                        'action': 'Klik på Download skabelon',
                        'label': 'Indberetninger fra fil'
                    }
                });
            })











        ;


    }

    return this;


}());